import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    border?: boolean;
  }>()
  .create(({ border, theme }) => ({
    searchInput: {
      padding: theme.spacing(0, 1),
      display: 'flex',
      alignItems: 'center',
      input: {
        padding: theme.spacing(1, 0)
      }
    },
    searchIcon: {
      color: theme.vars.palette.transparent.a25
    },
    clearIcon: {
      opacity: 0.8,
      marginRight: '-0.25rem',
      '&:hover': {
        opacity: 1,
        color: theme.vars.palette.secondary.dark
      }
    },
    quickSearch: {
      width: '100%',
      borderRadius: '0.25rem',
      border: `solid 1px ${
        border ? 'var(--mui-palette-border-main)' : 'transparent'
      }`,
      backgroundColor: `${
        border ? 'var(--mui-palette-background-elevation2)' : 'transparent'
      }`
    }
  }));

export default useStyles;
